const About = () => {
  return (
    <a
      href="#about"
      className="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
    >
      About
    </a>
  );
};

export default About;
